import useGetSlicedNumber from "@/use/useGetSlicedNumber";
import { HttpStatusCode } from "../httpStatusCode";

export interface IHttpError {
  status: number;
  name: string;
  message: string;
  time: string;
  data: any;
}

export class HttpError extends Error implements IHttpError {
  public status: number;
  public time: string;
  public data: any;

  constructor(status: number, time: string, message?: string, data?: any) {
    super(message);

    Object.setPrototypeOf(this, HttpError.prototype);
    this.status = status;
    this.name = HttpStatusCode[status];
    this.message = message || HttpStatusCode[status];
    this.time = time;
    this.data = data;
  }

  public isClientError(): boolean {
    // return this.status >= 400 && this.status <= 499;

    // e.g.서버 응답 404000000
    const arrangedStatus = useGetSlicedNumber(this.status, 0, 3);
    return arrangedStatus >= 400 && arrangedStatus <= 499;
  }

  public isServerError(): boolean {
    // return this.status >= 500 && this.status <= 599;

    // e.g.서버 응답 505000000
    const arrangedStatus = useGetSlicedNumber(this.status, 0, 3);
    return arrangedStatus >= 500 && arrangedStatus <= 599;
  }

  public static fromStatus(
    status: number,
    time: string,
    message?: string,
    data?: any
  ): HttpError {
    return new this(status, time, message, data);
  }
}

export const isHttpError = (e: Error): e is HttpError => {
  return Number.isInteger((e as HttpError).status);
};
